export class StatusReferenceModel {
    public statusCode: string;
    public displayName: string; 
}